export default class Label {
    static None: Label = new Label('None');

    constructor(public text: string) {}
}
